export const unsatisfiedReasonsPieConfig = {
  appendPadding: 10,
  angleField: "value",
  colorField: "reason",
  radius: 1,
  innerRadius: 0.6,
  label: {
    text: "value",
    style: {
      textAlign: "center",
      fontSize: 14
    }
  },
  interactions: [{ type: "element-selected" }, { type: "element-active" }],
  statistic: {
    title: "reason",
    content: {
      style: {
        whiteSpace: "pre-wrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }
    }
  },
  annotations: [
    {
      type: "text",
      style: {
        text: "Query Reasons",
        x: "50%",
        y: "50%",
        textAlign: "center",
        fontSize: 20,
        fontStyle: "bold"
      }
    }
  ]
};
